const API_URL = window.location.hostname === 'localhost' ? 'http://localhost:3000/' : 'https://api.ssm.casino/';

export const fetchWins = async () => {
    try {
        const response = await fetch(API_URL+'api/game/wins');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return (data.wins as IWin[]);
    } catch (error) {
        console.error('Error fetching wins:', error);
        return null;
    }
};

export interface IToken {
    name: string;
    symbol: string;
    amount: number;
    image: string;
}

export interface IWin {
    tx: string;
    date: string;
    tokens: IToken[];
}
